import React from 'react'
import ReactDOM from 'react-dom'
import './fonts/Aclonica/Aclonica-Regular.ttf'
import './fonts/BebasNeue/BebasNeue-Regular.ttf'
import './fonts/GrandHotel/GrandHotel-Regular.ttf'
import './fonts/LuckiestGuy/LuckiestGuy-Regular.ttf'
import './fonts/Pacifico/Pacifico-Regular.ttf'
import './fonts/PirataOne/PirataOne-Regular.ttf'
import './fonts/Ranchers/Ranchers-Regular.ttf'
import './fonts/Righteous/Righteous-Regular.ttf'
import './fonts/Risque/Risque-Regular.ttf'
import './fonts/Sriracha/Sriracha-Regular.ttf'
import './fonts/AkaPosse/AkaPosse.ttf'
import './fonts/Chomsky/Chomsky.woff'
import './fonts/Impact/Impact.ttf'
import './fonts/KgLetHerGo/KgLetHerGo.ttf'
import './fonts/KgLoveIsLoveIsLove/KgLoveIsLoveIsLove.ttf'
import './fonts/KGLuckoftheIrish/KGLuckoftheIrish.ttf'
import './fonts/VictoriaTypewriter/Victoria Typewriter Regular.ttf'
import './fonts/VictoriaTypewriter/Victoria Typewriter Bold.ttf'
import './fonts/VictoriaTypewriter/Victoria Typewriter Italic.ttf'
import './fonts/Indiana/Indiana.ttf'
import './fonts/Marker/Marker.ttf'
import './fonts/Zurich/Zurich.ttf'
import './fonts/HoltwoodOneSC/HoltwoodOneSC.ttf'
import './fonts/Laviossa/Laviossa.otf'
import './fonts/Redressed/Redressed.ttf'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
